import React from 'react';
import pick from 'lodash/pick';
import EditableSection from 'project/containers/brief_editable_section';
import { getVisibleBriefQuestions } from 'pap/utils';

/**
 * Materials brief section.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Materials = ({project, canEdit}) => {
  const briefQuestions = getVisibleBriefQuestions(project);
  /* contract section item is not part of the brief questions, so we must add it explicitly */
  let items = [
    {'name': 'contract', 'type': 'contract', 'answer_label': 'Contract', 'read_only': true}
  ]
  items = items.concat(briefQuestions.filter((q) => q.name == "file_upload"))
  return (<EditableSection canEdit={canEdit} title="Materials" items={items} project={project}/>)
}

export default Materials



// WEBPACK FOOTER //
// ./project/components/brief/materials.jsx